<div class="popup-global-layout width-650 p-4 p-md-5">
      <div class="d-flex justify-content-end"><mat-icon class="icon" (click)="close()">close</mat-icon></div>
      <div class="global-title">{{ 'payee.denied.pending' | translate }}</div>
      <div class="global-green-bar"></div>
      <div class="global-text">{{ 'payee.denied.pendingAccess' | translate }}</div>
      <div class="global-button-format">
          <button type="button" class="upsc-green-popup-button" (click)="close()">{{ 'payee.denied.ok' | translate }}<mat-icon class="icon-key2">keyboard_arrow_right</mat-icon></button>
      </div>
    </div>